import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef, HostListener,
  Inject,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BarclaysRequest } from '../entities/barclays-request.class';
import { environment } from '../../../../../environments/environment';
import { BarclaysFormLegacyComponent } from './../barclays-form-legacy/barclays-form-legacy.component';

@Component({
  selector: 'app-payment-barclays-legacy',
  templateUrl: './payment-barclays-legacy.component.html',
  styleUrls: ['./payment-barclays-legacy.component.scss'],
  standalone: false
})
export class PaymentBarclaysLegacyComponent implements OnInit, AfterViewInit {

  @ViewChild('iframeWithAllow') iframeWithAllow: ElementRef;
  @ViewChild('iframeWithoutAllow') iframeWithoutAllow: ElementRef;
  doc: any;
  compRef: ComponentRef<BarclaysFormLegacyComponent>;
  barclaysFormInfo: BarclaysRequest;
  allowAttribute = false;
  isReady = false;
  private shouldInitialize = false;
  isMobile = false;

  get iframe(): ElementRef {
    return this.iframeWithAllow || this.iframeWithoutAllow;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private vcRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private matDialogRef: MatDialogRef<PaymentBarclaysLegacyComponent>,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService
  ) {
    this.barclaysFormInfo = this.data.BarclaysRequest;
    this.checkNetwork();
  }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
  }

  ngAfterViewInit() {
    if (this.shouldInitialize) {
      this.initializeIframe();
    }
  }

  private initializeIframe() {
    if (this.iframe?.nativeElement) {
      this.doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
      this.startBarclaysPayment();
    }
  }

  private async checkNetwork() {
    const publicNetwork = await this.isPublicNetwork();
    if (!publicNetwork) {
      this.allowAttribute = true;
    }
    this.isReady = true;
    this.shouldInitialize = true;
    this.cdr.detectChanges();
    this.initializeIframe();
  }

  private async isPublicNetwork(): Promise<boolean> {
    try {
      const response = await fetch(`${window.location.origin}/index.html`, { method: 'HEAD' });
      return response.headers.has('x-cdn');
    } catch {
      return true;
    }
  }

  /**
   * Initializes the iframe and submits the Barclays Payment
   */
  startBarclaysPayment() {
    const componentFactory = this.resolver.resolveComponentFactory(BarclaysFormLegacyComponent);
    this.compRef = this.vcRef.createComponent(componentFactory);

    this.compRef.instance.barclaysFormInfo = this.barclaysFormInfo;
    this.doc.body.appendChild(this.compRef.location.nativeElement);
    this.compRef.instance.startBarclaysPayment();
  }

  /**
   * Handles the window.postMessage received from the iframe after the Barclays payment redirect
   * @param event object containing the postMessage event and the Barclays response data
   */
  @HostListener('window:message', ['$event'])
  onBarclaysResponseMessage(event) {
    // Check if event originated from our own app, close the dialog with null if not
    if (event.origin !== environment.webRoot) {
      this.matDialogRef.close(null);
      return;
    }
    // Only close dialog if event.data has a shaSign property
    if (event.data && typeof event.data === 'object' && 'shaSign' in event.data) {
      this.matDialogRef.close(event.data);
    }
  }

}
